
import { Reducer } from 'redux';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { AdministrationMessagesState } from './types-store';
import { reducer as messageListReducer, INITIAL_STATE as messageListState } from './list/reducers';
import { reducer as messageFormReducer, INITIAL_STATE as messageFormState } from './form/reducers';

export const INITIAL_STATE: AdministrationMessagesState = {
  list: messageListState,
  form: messageFormState
};

export const reducer: Reducer<AdministrationMessagesState> = mergeReducers({
  list: messageListReducer,
  form: messageFormReducer
});
